import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

export default function useDeleteExpense(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (expenseId: string) => expensesApi.remove(tourId, expenseId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.byTourId(tourId),
      });
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.global(),
      });
      queryClient.invalidateQueries({
        queryKey: tourDashboardApiQueryKeys.finance(tourId),
      });
      void invalidateAttentionQueries(queryClient, tourId);
      toast.success('Wydatek został usunięty');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Wystąpił błąd podczas usuwania wydatku.',
      });
    },
  });
}
